import { useQuery } from '@tanstack/react-query';
import { t } from 'i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

import {
  CURSOR_QUERY_PARAM,
  DataTable,
  LIMIT_QUERY_PARAM,
} from '@/components/ui/data-table';
import { TableTitle } from '@/components/ui/table-title';
import { AdminFlow, SeekPage } from '@activepieces/shared';
import { adminApi } from '@/features/internal-admin/lib/admin-api';
import { useAdminFlowsTable } from '@/features/internal-admin/lib/admin-flows-table';

const AdminFlowsPage = () => {
  const { columns, filters } = useAdminFlowsTable();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const queryParams = {
    cursor: searchParams.get(CURSOR_QUERY_PARAM) || undefined,
    limit: Number(searchParams.get(LIMIT_QUERY_PARAM)) || 10,
    search: searchParams.get('name') ?? undefined,
    externalId: searchParams.get('externalId') ?? undefined,
    externalCustomerId: searchParams.get('externalCustomerId') ?? undefined,
    status:
      searchParams.getAll('status').length > 0
        ? searchParams.getAll('status')
        : undefined,
  };

  const { data, isLoading, isError } = useQuery<SeekPage<AdminFlow>, Error>({
    queryKey: ['admin-flows', queryParams],
    queryFn: () => adminApi.listFlows(queryParams),
  });

  if (isError) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-destructive">{t('Failed to load flows')}</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full">
      <TableTitle>{t('Flows')}</TableTitle>
      <DataTable
        columns={columns}
        page={data}
        isLoading={isLoading}
        filters={filters}
        onRowClick={(row, newWindow) => {
          const url = `/internal-admin/flows/${row.tenantId}/${row.id}`;
          if (newWindow) {
            window.open(url, '_blank');
          } else {
            navigate(url);
          }
        }}
      />
    </div>
  );
};

export default AdminFlowsPage;
